import { Link } from "react-router-dom";
import SimplifiedHeader from '../components/SimplifiedHeader'
import Cta from '../components/Cta'
import ConfirmForm from './ConfirmForm'
import NotificationBar from '../components/NotificationBar'
import useTitle from '../hooks/useTitle'

function ConfirmApp() {
  useTitle("Reset Password | The Convoy | Save on everyday business expenses.");

  return (
    <div>
      <SimplifiedHeader showLogin="true" />
      <NotificationBar />
      <div className="container mx-auto bg-white">
        <div className="bg-white">
          <div className="md:max-w-login-container mx-auto text-center py-12">
            <div className="flex flex-wrap">
                <h2 className="flex-grow font-extrabold tracking-tight text-gray-900 sm:text-4xl">
                  <span className="font-header text-login-hero-mobile md:text-login-hero block">Reset your password</span>
                </h2>
            </div>
  
            <div className="mt-5 md:mt-10 font-subtitle flex-none max-w-2xl mx-auto">
              <span className="text-grey-dark text-subtitle-mobile md:text-subtitle">Enter your new password below.</span>
            </div>
  
            <ConfirmForm />
  
          </div>
      </div>
    </div>
    </div>
  )
}

export default ConfirmApp;

